import request from "superagent"
import prefix from "superagent-prefix"

export default request
  .agent()
  .query({ key: "ce52728f580499be6d00e2acbe8b996f", origin: "digital-signage" })
  .use(prefix(process.env.REACT_APP_API_ENDPOINT))



// WEBPACK FOOTER //
// ./src/store/api.js